var _path, _path2, _path3;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgExportOrangeIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M2.00001 9.33337C2.3682 9.33337 2.66668 9.63185 2.66668 10V12.6667C2.66668 12.8435 2.73691 13.0131 2.86194 13.1381C2.98696 13.2631 3.15653 13.3334 3.33334 13.3334H12.6667C12.8435 13.3334 13.0131 13.2631 13.1381 13.1381C13.2631 13.0131 13.3333 12.8435 13.3333 12.6667V10C13.3333 9.63185 13.6318 9.33337 14 9.33337C14.3682 9.33337 14.6667 9.63185 14.6667 10V12.6667C14.6667 13.1971 14.456 13.7058 14.0809 14.0809C13.7058 14.456 13.1971 14.6667 12.6667 14.6667H3.33334C2.80291 14.6667 2.2942 14.456 1.91913 14.0809C1.54406 13.7058 1.33334 13.1971 1.33334 12.6667V10C1.33334 9.63185 1.63182 9.33337 2.00001 9.33337Z",
    fill: "#FB7B33"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.19526 6.19526C4.45561 5.93491 4.87772 5.93491 5.13807 6.19526L8 9.05719L10.8619 6.19526C11.1223 5.93491 11.5444 5.93491 11.8047 6.19526C12.0651 6.45561 12.0651 6.87772 11.8047 7.13807L8.4714 10.4714C8.21106 10.7318 7.78894 10.7318 7.5286 10.4714L4.19526 7.13807C3.93491 6.87772 3.93491 6.45561 4.19526 6.19526Z",
    fill: "#FB7B34"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M8.00001 1.33337C8.3682 1.33337 8.66668 1.63185 8.66668 2.00004V10C8.66668 10.3682 8.3682 10.6667 8.00001 10.6667C7.63182 10.6667 7.33334 10.3682 7.33334 10V2.00004C7.33334 1.63185 7.63182 1.33337 8.00001 1.33337Z",
    fill: "#FB7B34"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgExportOrangeIcon);
export default __webpack_public_path__ + "static/media/export-orange-icon.34172bcf0c89ec15e67d2a21f85e95f8.svg";
export { ForwardRef as ReactComponent };